<div class="modal-header">
    <h4 class="modal-title">{{'manageEndPlates.title.add'| translate}}</h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner d-flex align-content-center">
    <form class="m-1 w-100" novalidate [formGroup]="form">
      <div class="col-12 mb-3 row align-content-center">
        <label class="col-md-4 col-form-label">{{'manageEndPlates.otherArticleNumber' | translate}}</label>
        <div class="col-md-8">
          <input type="text"
                  class="form-control"
                  [class.is-invalid]="form.controls?.otherArticleNo?.touched && form.controls?.otherArticleNo?.invalid"
                  formControlName="otherArticleNo"
                  name="otherArticleNo">
        </div>
        <div *ngIf="form.controls?.otherArticleNo?.touched && form.controls?.otherArticleNo?.invalid" class="ps-3 invalid-feedback d-flex">{{getInputError(form.get('otherArticleNo'))}}</div>
      </div>
      <div class="col-12 mb-3 row align-content-center">
          <label class="col-md-4 col-form-label">{{'manageEndPlates.rotated' | translate}}</label>
          <div class="col-md-8 form-check">
            <input type="checkbox"
                    class="form-check-input"
                    formControlName="rotated"
                    name="rotated"
                    [(ngModel)] ="rotated"
                    id="rotated">
                    <label class="col-md-4 col-form-label form-check-label" for="rotated"></label>
          </div>
      </div>
    </form>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary btn-cancel" (click)="close()">
    {{'global.label.cancel' | translate}}
  </button>
  <button [disabled]="form.invalid || !form.dirty" class="btn btn-primary" (click)="save()">
    {{'global.label.add' | translate}}
  </button>
</div>
